module.exports = __webpack_public_path__ + "img/fourday1-1.5d8ffbd2.jpg";